export const scrollToSection = () => {

  function scrollToSmoothly(pos, time) {
    var currentPos = window.pageYOffset;
    var start = null;
    if(time == null) time = 500;
    pos = +pos, time = +time;
    window.requestAnimationFrame(function step(currentTime) {
        start = !start ? currentTime : start;
        var progress = currentTime - start;
        if (currentPos < pos) {
            window.scrollTo(0, ((pos - currentPos) * progress / time) + currentPos);
        } else {
            window.scrollTo(0, currentPos - ((currentPos - pos) * progress / time));
        }
        if (progress < time) {
            window.requestAnimationFrame(step);
        } else {
            window.scrollTo(0, pos);
        }
    });
  }

  const headerMenu = document.querySelector(".header__menu");
  const headerBurger = document.querySelector(".header__burger");

  document.getElementById("link_about").addEventListener("click", function(e){
    scrollToSmoothly(document.querySelector('.about').offsetTop, 300 /* milliseconds */);
    if (headerMenu.classList.contains("header__menu_open")) {
      headerMenu.classList.remove("header__menu_open");
      headerBurger.classList.remove("header__burger_open");
    }
  });
  document.getElementById("link_speakers").addEventListener("click", function(e){
    scrollToSmoothly(document.querySelector('.speakers').offsetTop, 400 /* milliseconds */);
    if (headerMenu.classList.contains("header__menu_open")) {
      headerMenu.classList.remove("header__menu_open");
      headerBurger.classList.remove("header__burger_open");
    }
  });
  document.getElementById("link_program").addEventListener("click", function(e){
    scrollToSmoothly(document.querySelector('.program').offsetTop, 500 /* milliseconds */);
    if (headerMenu.classList.contains("header__menu_open")) {
      headerMenu.classList.remove("header__menu_open");
      headerBurger.classList.remove("header__burger_open");
    }
  });
  document.getElementById("link_partners").addEventListener("click", function(e){
    scrollToSmoothly(document.querySelector('.partners').offsetTop, 600 /* milliseconds */);
    if (headerMenu.classList.contains("header__menu_open")) {
      headerMenu.classList.remove("header__menu_open");
      headerBurger.classList.remove("header__burger_open");
    }
  });
  document.getElementById("link_footer").addEventListener("click", function(e){
    scrollToSmoothly(document.querySelector('.footer').offsetTop, 700 /* milliseconds */);
    if (headerMenu.classList.contains("header__menu_open")) {
      headerMenu.classList.remove("header__menu_open");
      headerBurger.classList.remove("header__burger_open");
    }
  });



  const buttonTop = document.querySelector(".button-top");

  window.addEventListener('scroll',(event) => {
    if ( window.scrollY > 600 ) {
      buttonTop.style.display = "flex";
    } else {
      buttonTop.style.display = "none";
    }
  });

  buttonTop.addEventListener("click", function(){
    scrollToSmoothly(document.querySelector('.first-screen').offsetTop, 500 /* milliseconds */);
  });

  
}